import type { PaperProps as MantinePaperProps } from '@mantine/core';
import { Paper as MantinePaper } from '@mantine/core';
import type { ReactNode } from 'react';
import { Title } from './Title';

interface InfoBoxProps extends MantinePaperProps {
	title?: string | ReactNode;
	headerContent?: ReactNode;
	children?: ReactNode;
	withPadding?: boolean;
}

export function Paper({
	title,
	children,
	headerContent,
	withPadding = false,
	...paperProps
}: InfoBoxProps) {
	const fieldsetProps = {
		w: '100%',
		p: withPadding ? '23' : 'lg',
	};

	const shadow = 'rgba(17, 12, 46, 0.09) 0px 48px 100px 0px';
	// const shadow = 'rgba(149, 157, 165, 0.2) 0px 8px 24px';
	return (
		<>
			<MantinePaper {...fieldsetProps} shadow={shadow} {...paperProps}>
				{title && <Title label={title} rightContent={headerContent} />}
				{children}
			</MantinePaper>
		</>
	);
}
